__turbopack_context__.v({
  "centered": "AppTitle-module-scss-module__JvOvzW__centered",
  "md": "AppTitle-module-scss-module__JvOvzW__md",
  "root": "AppTitle-module-scss-module__JvOvzW__root",
});
